<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.Id ? '新增' : '编辑'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="hanlerClose"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      label-width="120px"
    >
      <el-form-item prop="KeyName" label="名称">
        <el-input v-model="dataForm.KeyName" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item prop="KeyType" label="字典类型">
        <el-input v-model="dataForm.KeyType" placeholder="字典类型"></el-input>
      </el-form-item>
      <el-form-item prop="Sort" label="排序">
        <el-input-number
          v-model="dataForm.Sort"
          controls-position="right"
          :min="0"
          label="排序"
        ></el-input-number>
      </el-form-item>
      <el-form-item prop="Remark" label="备注">
        <el-input v-model="dataForm.Remark" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="hanlerClose">关闭</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        Id: "",
        KeyName: "",
        KeyType: "",
        Sort: 0,
        Remark: "",
      },
    };
  },
  computed: {
    dataRule() {
      return {
        KeyName: [
          {
            required: true,
            message: "请输入字典名称",
            trigger: "blur",
          },
        ],
        KeyType: [
          {
            required: true,
            message: "请输入字典类型",
            trigger: "blur",
          },
        ],
        Sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    init() {
      this.visible = true;
    },
    hanlerClose() {
      this.$refs.dataForm.resetFields();
      this.visible = false;
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let dataForm = JSON.parse(JSON.stringify(this.dataForm));
          if (!dataForm.Id) {
            delete dataForm.Id;
          }
          this.$http
            .post(
              !dataForm.Id
                ? "/api/Dictionary/AddDictionaryKey"
                : "/api/Dictionary/ModifyDictionaryKey",
              dataForm
            )
            .then(({ data: res }) => {
              this.$message({
                message: res.msg || "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.hanlerClose();
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
